import * as tslib_1 from "tslib";
import { findContactsByEmail, findPeopleByEmail } from '../services/people/findPeopleByEmail';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
export default function getPersonaByEmail(emailAddress, displayName, includeMailboxAndDirectory) {
    return includeMailboxAndDirectory
        ? findContactsAndRecipientCacheEntriesByEmail(emailAddress, displayName)
        : getConcreteContactByEmail(emailAddress, displayName);
}
function findContactsAndRecipientCacheEntriesByEmail(emailAddress, displayName) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var people, contacts, response, _a, personasForDisplayName, personaToReturn;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    people = findPeopleByEmail(emailAddress);
                    return [4 /*yield*/, findContactsByEmail(emailAddress)];
                case 1:
                    contacts = _b.sent();
                    if (!(contacts.personas && contacts.personas.length > 0)) return [3 /*break*/, 2];
                    _a = contacts;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, people];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    // We can get several hits for the given email with different displayNames, to avoid confusion for the user
                    // we use the one favorited
                    if (response.personas && response.personas.length > 0) {
                        personasForDisplayName = response.personas.filter(function (persona) {
                            return persona.DisplayName &&
                                displayName &&
                                persona.DisplayName.toLocaleLowerCase() === displayName.toLocaleLowerCase();
                        });
                        if (personasForDisplayName.length > 0) {
                            return [2 /*return*/, personasForDisplayName[0]];
                        }
                        personaToReturn = response.personas[0];
                        // Contact from the recipient cache without a proper displayName,
                        // fall back on the provided display name
                        if (personaToReturn.DisplayName === emailAddress &&
                            personaToReturn.EmailAddress.MailboxType === 'OneOff') {
                            logUsage(datapoints.OneOffAddressUsedForFavorite.datapoint.name);
                            return [2 /*return*/, tslib_1.__assign({}, personaToReturn, { DisplayName: displayName })];
                        }
                        return [2 /*return*/, personaToReturn];
                    }
                    else {
                        trace.warn("Cannot find persona by email: " + emailAddress);
                        throw new Error("Persona not found (people: " + response.requestId + ", contacts: " + contacts.requestId + ", length: " + (emailAddress ? emailAddress.length : 'no email address') + ")");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * If multiple contacts are found for the given email, the one with DisplayName equal to displayNameHint is returned.
 * Otherwise, we return the dirst one
 */
function getConcreteContactByEmail(emailAddress, displayNameHint) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var contacts, personasForDisplayName;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, findContactsByEmail(emailAddress)];
                case 1:
                    contacts = _a.sent();
                    // We can get several hits for the given email with different displayNames, to avoid confusion for the user
                    // we use the one favorited
                    if (contacts.personas && contacts.personas.length > 0) {
                        personasForDisplayName = contacts.personas.filter(function (persona) {
                            return persona.DisplayName &&
                                displayNameHint &&
                                persona.DisplayName.toLocaleLowerCase() === displayNameHint.toLocaleLowerCase();
                        });
                        if (personasForDisplayName.length > 0) {
                            return [2 /*return*/, personasForDisplayName[0]];
                        }
                        return [2 /*return*/, contacts.personas[0]];
                    }
                    else {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getPersonaByEmail.js.map